import { Box } from "@mui/material";
import './style.scss';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import '@fontsource/ibm-plex-sans';
import '@fontsource/ibm-plex-sans/600.css';

interface PaletteFundColumm {
    pointerLeft: any;
    status: string;
}

export default function PaletteFund({ pointerLeft, status }: PaletteFundColumm) {
    return (
        <Box className="palette-fund" sx={{
            '--pointer-left': pointerLeft
        } as any}>
            <Box className="palette-bar">
                <Box className="palette-label left">Thấp</Box>
                <Box className="palette-label right">Cao</Box>

                <Box className="palette-color" style={{ backgroundColor: '#00A758' }} />
                <Box className="palette-color" style={{ backgroundColor: '#FCC457' }} />
                <Box className="palette-color" style={{ backgroundColor: '#F49600' }} />
                <Box className="palette-color" style={{ backgroundColor: '#CE7612' }} />
                <Box className="palette-color" style={{ backgroundColor: '#EC6453' }} />

                <Box className="palette-pointer" style={{ left: pointerLeft }}>
                    <Box component="span" className="triangle-pointer" />
                </Box>
            </Box>

            {status && <Box className="palette-status" style={{ left: pointerLeft }}>{status}</Box>}
        </Box>
    );
}
